import { render, staticRenderFns } from "./mangoTreeDetail.vue?vue&type=template&id=a79ca698&scoped=true&"
import script from "./mangoTreeDetail.vue?vue&type=script&lang=js&"
export * from "./mangoTreeDetail.vue?vue&type=script&lang=js&"
import style0 from "./mangoTreeDetail.vue?vue&type=style&index=0&id=a79ca698&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a79ca698",
  null
  
)

export default component.exports